<template>
  <div class="manager">
    <div class="row-1">
      <div class="left">
        <div class="item item-1">
          <div class="title">{{ new Date().getMonth() + 1 }}月营收</div>
          <div class="content">￥{{ currentMonthRevenueData }}</div>
        </div>
        <div class="item item-2">
          <div class="title">今日订单数</div>
          <div class="content">{{ bulletinBoardData.todayOrderCount }}</div>
        </div>
        <div class="item item-3">
          <div class="title">今日入住人数</div>
          <div class="content">
            {{ bulletinBoardData.todayCheckInPeopleCount }}
          </div>
        </div>
        <div class="item item-4">
          <div class="title">今日房费</div>
          <div class="content">{{ bulletinBoardData.todayRevenue }}</div>
        </div>
      </div>
      <div class="right block">
        <div class="block-wrapper">
          <div class="title">今日售卖情况</div>
          <div class="content" style="display: flex; justify-content: center;">
            <div id="chart1" style="width: 200px; height: 300px;"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="row-2">
      <div class="left block">
        <div class="block-wrapper">
          <div class="title">入住概览</div>
          <div class="content" v-if="checkInOverviewData">
            <el-tabs v-model="activeName" @tab-click="onTabChange">
              <el-tab-pane
                v-if="checkInOverviewData.preArrive"
                :label="`今日预抵(${checkInOverviewData.preArrive.count || 0})`"
                name="1"
              ></el-tab-pane>
              <el-tab-pane
                v-if="checkInOverviewData.preLeave"
                :label="`今日预离(${checkInOverviewData.preLeave.count || 0})`"
                name="2"
              ></el-tab-pane>
              <el-tab-pane
                v-if="checkInOverviewData.currentCheckIn"
                :label="`当前在住(${
                  checkInOverviewData.currentCheckIn.count || 0
                })`"
                name="3"
              ></el-tab-pane>
            </el-tabs>
            <el-table
              ref="TableRef"
              :data="tableData"
              style="width: 100%"
              height="300"
            >
              <el-table-column prop="orderSourceName" label="来源" />
              <el-table-column prop="bookerName" label="预订人" />
              <el-table-column prop="bookerPhone" label="预订人电话" />
              <el-table-column prop="roomTypeName" label="房型" />
              <el-table-column prop="roomName" label="房源" />
              <el-table-column prop="orderPrice" label="房费" />
              <el-table-column
                align="left"
                width="300px"
              >
                <template #header>
                  <div>抵离时间</div>
                </template>
                <template #default="scope">
                  <div class="order-time-block">
                    <div>
                      <div>
                        <span class="order-time-label-1">抵</span
                        >{{
                          scope.row.orderState == 3 || scope.row.orderState == 4
                            ? scope.row.actualCheckInTime
                            : scope.row.proposedCheckInTime
                        }}
                      </div>
                      <div>
                        <span class="order-time-label-2">离</span
                        >{{
                          scope.row.orderState == 4
                            ? scope.row.actualCheckOutTime
                            : scope.row.proposedCheckOutTime
                        }}
                      </div>
                    </div>
                    <!-- <div class="order-timestr-block">
                      共{{ getDiffTimeStr(scope.row) }}
                    </div> -->
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="入住时长">
                <template #default="{ row }">
                  {{
                    getDiffTime(
                      row.proposedCheckInTime,
                      row.proposedCheckOutTime,
                      row.orderType
                    )
                  }}
                  {{ { 1: "晚", 2: "小时" }[row.orderType] }}
                </template>
              </el-table-column>
              <el-table-column prop="date" label="操作">
                <span style="cursor: pointer;" @click="checkDetail">查看详情</span>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="right block">
        <div class="block-wrapper">
          <div class="title">
            <span>订单来源分布</span>
            <el-select
              v-model="orderType"
              placeholder="请选择统计范围"
              @change="getOrderSourceSpread"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
          <div class="content" style="display: flex; justify-content: center">
            <div id="chart2" style="width: 100%; height: 350px"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import setChart from "./setChart.js";
import { mapActions } from "vuex";
import tableMix from "@/components/common/tableListMixin.js";
import orderMix from "@/views/baseInfo/order/mixin";
import { formatTime } from "@/utils/index.js";

export default {
  mixins: [tableMix, orderMix],
  data() {
    return {
      orderType: "0",
      options: [
        {
          value: "0",
          label: "累计",
        },
        {
          value: "1",
          label: "近7天",
        },
        {
          value: "2",
          label: "本月",
        },
        {
          value: "3",
          label: "本年",
        },
      ],
      tableData: [],
      activeName: "1",
      storeId: "",
      bulletinBoardData: {},
      currentMonthRevenueData: 0,
      checkInOverviewData: {},
    };
  },
  methods: {
    ...mapActions(["fetchData"]),
    checkDetail(){
      
    },
    getData(){
      this.getBulletinBoard();
      this.getCheckInOverview();
      this.getCurrentMonthRevenue();
      this.getOrderSourceSpread();
      this.getTodayRoomSold();
      this.setChart1();
      this.setChart2();
    },
    onTabChange(e) {
      this.tableData =
        this.checkInOverviewData[
          ["preArrive", "preLeave", "currentCheckIn"][e.index]
        ].orderList;
    },
    getBulletinBoard() {
      this.fetchData({
        url: "MANAGER.BULLETIN_BOARD",
        methods: "get",
        headers: { "Content-Type": "application/json" },
        params: { storeId: this.storeId },
      }).then((res) => {
        this.bulletinBoardData = res;
      });
    },
    // getCheckInOverview() {
    //   this.fetchData({
    //     url: "MANAGER.CHECK_IN_OVERVIEW",
    //     methods: "get",
    //     headers: { "Content-Type": "application/json" },
    //     params: { storeId: this.storeId },
    //   }).then((res) => {
    //     this.checkInOverviewData = res;
    //     this.tableData = this.checkInOverviewData.preArrive.orderList;
    //   });
    // },
    async getCheckInOverview() {
      const res = {
        preArrive: await this.getQuery(1),
        preLeave: await this.getQuery(2),
        currentCheckIn: await this.getQuery(3),
      }
      this.checkInOverviewData = res;
      this.tableData = this.checkInOverviewData.preArrive.orderList;
    },
    // 查询列表数据
    getQuery(type) {
      // type 1今日预抵 2今日欲离 3当前在住
      const params = { storeId: this.storeId, pageNumber: 1, pageSize: 99 };
      const today = new Date();
      const [start, end] = [today.setHours(0, 0, 0, 0), today.setHours(23, 59, 59, 59)].map(time => formatTime(time, 'yyyy-MM-dd HH:mm'));
      formatTime()
      if(type == 1){
        params.orderState = 2;
        params.proposedCheckInStartTime = start;
        params.proposedCheckInEndTime = end;
      }
      if(type == 2){
        params.orderState = 3;
        params.proposedCheckOutStartTime = start;
        params.proposedCheckOutEndTime = end;
      }
      if(type == 3){
        params.orderState = 3;
      }
      return this.fetchData({
        url: 'SAAS.ORDER_QUERY_LIST',
        method: 'get',
        params,
      })
        .then((res) => {
          console.log(res.data, res.rowCount);
          return {
            count: res.rowCount,
            orderList: res.data,
          }
        });
    },
    getCurrentMonthRevenue() {
      this.fetchData({
        url: "MANAGER.CURRENT_MONTH_REVENUE",
        methods: "get",
        headers: { "Content-Type": "application/json" },
        params: { storeId: this.storeId },
      }).then((res) => {
        this.currentMonthRevenueData = res;
      });
    },
    getOrderSourceSpread() {
      this.fetchData({
        url: "MANAGER.ORDER_SOURCE_SPREAD",
        methods: "get",
        headers: { "Content-Type": "application/json" },
        params: { storeId: this.storeId, type: this.orderType },
      }).then((res) => {
        if (res) {
          this.setChart2(
            res.map((e) => ({ name: e.sourceName, value: e.orderCount }))
          );
        }
      });
    },
    getTodayRoomSold() {
      this.fetchData({
        url: "MANAGER.TODAY_ROOM_SOLD",
        methods: "get",
        headers: { "Content-Type": "application/json" },
        params: { storeId: this.storeId },
      }).then((res) => {
        this.setChart1(res ? res.todaySold : 0, res ? res.todayUnSold : 0);
      });
    },
    setChart1(sold = 0, unSold = 0) {
      setChart("#chart1", {
        legend: {
          top: "5%",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        series: [
          {
            type: "pie",
            radius: ["40%", "70%"],
            label: {
              show: false,
            },
            data: [
              { value: sold, name: "已售" },
              { value: unSold, name: "可售" },
            ],
          },
        ],
      });
    },
    setChart2(data = []) {
      setChart("#chart2", {
        title: {
          text: "渠道",
          left: "center",
          top: "46%",
          textStyle: {
            align: "center",
          },
        },
        legend: {
          left: "left",
          orient: "vertical",
        },
        tooltip: {
          trigger: "item",
        },
        series: [
          {
            type: "pie",
            radius: ["20%", "50%"],
            label: {
              show: false,
            },
            data,
          },
        ],
      });
    },
  },
  mounted() {
    const curStoreInfo = this.getCurStoreInfo();
    if (curStoreInfo && curStoreInfo.id) {
      this.storeId = curStoreInfo.id;
    }
    this.getData();
    // 监听全局门店切换
    this.$eventBus.on('change-shop', store => {
      this.storeId = store.id;
      this.getData();
    })
  },
};
</script>



<style scoped lang="less">
.manager {
  .block {
    background-color: white;
    border-radius: 8px;
    box-shadow: 1px 1px 2px 0px rgba(82, 90, 102, 0.04),
      2px 2px 8px 0px rgba(82, 90, 102, 0.08);
    .block-wrapper {
      padding: 16px 32px;
      .title {
        font-size: 20px;
        color: #091136;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .content {
      }
    }
  }
  .row-1 {
    display: flex;
    margin-bottom: 16px;
    .left {
      flex: 2;
      display: flex;
      justify-content: space-between;
      padding: 0 1px;
      margin-right: 16px;
      .item {
        background-color: white;
        flex: 2;
        margin-right: 16px;
        border-radius: 8px;
        padding: 16px;
        color: white;
        &:last-child {
          margin-right: 0;
        }
        .title {
          font-size: 18px;
        }
        .content {
          font-size: 40px;
          margin-top: 46px;
          text-align: center;
        }
      }
      .item-1 {
        background-image: url("~@/assets/img/item-1.png");
        background-size: 100% 100%;
        flex: 3;
      }
      .item-2 {
        background-image: url("~@/assets/img/item-2.png");
        background-size: 100% 100%;
      }
      .item-3 {
        background-image: url("~@/assets/img/item-3.png");
        background-size: 100% 100%;
      }
      .item-4 {
        background-image: url("~@/assets/img/item-4.png");
        background-size: 100% 100%;
      }
    }
    .right {
      flex: 1;
    }
  }
  .row-2 {
    display: flex;
    .left {
      flex: 2;
      margin-right: 16px;
    }
    .right {
      flex: 1;
    }
  }
  .chart {
    width: 300px;
    height: 200px;
  }
}
.order-timestr-block {
  margin-left: 20px;
}
.order-time-label-1,
.order-time-label-2 {
  padding: 3px;
  width: 22px;
  height: 22px;
  background-color: #52b82f;
  border-radius: 5px;
  color: #fff;
  font-weight: 500;
  font-size: 12px;
  margin-right: 20px;
}
.order-time-label-2 {
  background-color: #fe4d4d;
}
</style>